( function ( $ ) {
	const changeLanguage = ( lang, url ) => {
		$.ajax( {
			url: '/wp-admin/admin-ajax.php',
			data: {
				'action': 'process_lang_change',
				'lang': lang,
			},
			type: 'POST',
			dataType: 'JSON',
			success: function () {
				document.location.href = url;
			},
		} );
	};

	$( 'div.js-language' ).on('click', e => changeLanguage( e.currentTarget.dataset.slug, e.currentTarget.dataset.value ) );

	$( 'select.js-language' ).on('change', e => {
		const option = e.currentTarget.querySelector( 'option:checked' );

		changeLanguage( option.dataset.slug, option.dataset.value );
	} );

	$( 'div.js-shipping' ).on('click', function () {
		window.Checkout.countryChangeProcess( this.dataset.value, false, true );
	} );

	$( 'select.js-shipping' ).on('change', e => window.Checkout.countryChangeProcess( e.currentTarget.value, false, true ) );
} )( jQuery );

let Language = {};

Language.init = function () {
	let languageOverlay = $( '.js-language-overlay' );

	// Cart Overlay
	if ( !$( 'body' ).is( '.isApple, .AndroidOS' ) ) {
		languageOverlay.hover( function () {
			$( 'body' ).addClass( 'language-overlay' );
		}, function () {
			$( 'body' ).removeClass( 'language-overlay' );
		} );
	}
};

Language.init();



// WEBPACK FOOTER //
// ./scripts/components/language.js